// sessionReset.ts - discards user-specific state when the session epoch advances
// (see sessionIdentity.ts). Component state is reset separately by remounting the
// app subtree on the epoch (SessionBoundary in ConditionalAuthProvider).

import store, { resetUserScopedState } from '../redux/store/store';
import currentUserAccessService from './currentUserAccessService';
import { clearPendingActionLaunches } from './pendingActionLaunchStorage';
import { resetRtuActionHintSharing } from './rtuService';
import { subscribeSessionEpoch } from './sessionIdentity';

subscribeSessionEpoch(() => {
  store.dispatch(resetUserScopedState());
  currentUserAccessService.invalidate();
  resetRtuActionHintSharing();
  clearPendingActionLaunches();
});
